/**
 * @generated SignedSource<<3e94f45f90eb2e4e1d13c0ff5757748d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventEditScreenComponent_event$data = {
  readonly endAt: {
    readonly isoString: string;
  };
  readonly id: string;
  readonly isAllDayEvent: boolean;
  readonly startAt: {
    readonly isoString: string;
  };
  readonly storeCalendar: {
    readonly id: string;
    readonly isExternal: boolean;
  };
  readonly title: string;
  readonly " $fragmentType": "CalendarTeamEventEditScreenComponent_event";
};
export type CalendarTeamEventEditScreenComponent_event$key = {
  readonly " $data"?: CalendarTeamEventEditScreenComponent_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditScreenComponent_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarTeamEventEditScreenComponent_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAt",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAt",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAllDayEvent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreCalendar",
      "kind": "LinkedField",
      "name": "storeCalendar",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CalendarEvent",
  "abstractKey": null
};
})();

(node as any).hash = "a3b27b1db6c864c478f38e5cbf2f94d7";

export default node;
